var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('h3',[_c('b',[_vm._v(_vm._s(_vm.message))])]):_c('section',{staticClass:"employee-work-time-controls-list"},_vm._l((_vm.employees),function({
      description,
      id,
      name,
      nextAction,
      isAssistant,
      doctorsToAssist,
      doctorAssist,
    }){return _c('employee-work-time-controls-list-item',{key:`employee-work-time-controls:employees:${id}`,staticClass:"employee-work-time-controls employee-work-time-controls-list__item",attrs:{"name":name,"employee-id":id,"description":description,"next-action":nextAction,"is-assistant":isAssistant,"doctors-to-assist":doctorsToAssist,"doctor-assist":doctorAssist},on:{"employee-counter-start":_vm.onEmployeeStart,"employee-counter-stop":_vm.onEmployeeStop}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }